import getMeshFromModel from "../getMeshFromModel";
import { moon } from "./assets/props";

const Moon = () => {
  const moonMesh = getMeshFromModel(moon);
  return moonMesh;
};

export default Moon;
